import { CognitoIdToken } from "@goodfill/backend-api-client";

const ENDPOINT_URL = `${import.meta.env.VITE_BACKEND_BASE_URL}/customer-application/initiateDocumentUpload`;

export type DOCUMENT_UPLOAD_TYPE = "ProofOfIdentity" | "ProofOfAddress";

export async function uploadDocumentForApplicationForm(
  type: DOCUMENT_UPLOAD_TYPE,
  file: File,
  cognitoIdToken: CognitoIdToken,
): Promise<string> {
  const initiateUploadResult = await (
    await fetch(ENDPOINT_URL, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${cognitoIdToken}`,
      },
      body: JSON.stringify({ documentType: type }),
    })
  ).json();

  const uploadUrl = initiateUploadResult.s3PutObjectUrl;

  await fetch(uploadUrl, {
    method: "PUT",
    body: file,
  });

  if (!initiateUploadResult.documentId) {
    throw new Error("Missing 'documentId' in file upload resposne");
  }

  return initiateUploadResult.documentId;
}
